// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Prefill: Sätze des letzten Eintrags derselben Übung vorbelegen (Prototyp-Verhalten)
import type { WorkoutEntry, SetEntry } from "./types"
import { DEFAULT_SETS } from "./sets"
import { dayOf } from "./dates"

/** Neuester Eintrag (synced ∪ pending) dieser Übung, oder null. */
export function lastEntryFor(entries: WorkoutEntry[], exerciseId: string): WorkoutEntry | null {
  const list = entries
    .filter((e) => e.exercise === exerciseId)
    .sort((a, b) => dayOf(a.date).localeCompare(dayOf(b.date)))
  return list.at(-1) ?? null
}

/** Startwerte für die Satzliste: letzte Werte kopieren, sonst Default.
 *  Zeilenzahl = max(targetSets, Sätze des letzten Eintrags) — fehlende Zeilen
 *  werden mit dem letzten Satz aufgefüllt (Anforderung A2: „3×8" → 3 Zeilen). */
export function prefillSets(entries: WorkoutEntry[], exerciseId: string, targetSets = 0, bodyweight = false): { sets: SetEntry[]; prefilled: boolean } {
  const last = lastEntryFor(entries, exerciseId)
  // Körpergewicht (A3): Default ohne Phantom-20kg
  const fallback: SetEntry[] = bodyweight ? [{ reps: 12, weight_kg: 0 }] : DEFAULT_SETS
  const source = last?.sets?.length ? last.sets : fallback
  // Bei Körpergewichtsübungen NIE ein Gewicht vorbelegen: ein einziger alter
  // Falscheintrag (z. B. 12×20 kg am Crosstrainer) würde die Gewichtsspalte
  // sonst für immer wieder aufklappen. Zusatzgewicht trägt man bewusst ein.
  const sets = source.map((s) => ({ ...s, weight_kg: bodyweight ? 0 : s.weight_kg }))
  while (sets.length < targetSets) sets.push({ ...sets[sets.length - 1] })
  return { sets, prefilled: Boolean(last?.sets?.length) }
}
